export default function(el) {
  return (el.getBoundingClientRect().top + (document.documentElement.scrollTop || document.body.scrollTop));
}
